// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-vis-container{
  min-width: -moz-fit-content;
  min-width: fit-content;
  background-color: rgba(0, 0, 0, 0.062);
  margin: 10px 2rem;
  padding: 1.2rem;
}
.practice-bullet-point{
  min-width: calc(100% - 4rem);
  min-height: 40px;
  margin: 10px 2rem;
  font-size: 1.2rem;
  font-weight: bolder;
  line-height: 40px;
  text-shadow: 3px 3px 3px rgba(226, 223, 223, 0.747);
  list-style-type: circle;
  background-color: #ffb70031;
  box-shadow: 4px 4px 10px #00000042;
}

.apply-button{
  width: 150px;
  height:30px;
  font-size: 12px;
  text-align: center;
  
}


.progress-label,
.epoch-count{
  width: 120px;
  height: 30px;
  font-size: 1.2rem;
  font-weight: bolder;
  line-height: 30px;
}


.optimizer-info-table tr td{
  padding: 5px;
  border: 1px solid black;
  width: 200px;
  font-size: 1.2rem;
  font-weight: bolder;
  text-align: center;
  background-color: white;
  box-shadow: 1px 1px 5px grey;
}



/* Practice */

.data-description{
  width: 100%;
  height: 80px;
  line-height: 35px;

  font-weight: bolder;
  padding: 5px;

}

.data-loss-description{
  width: 100%;
  height: 40px;
  line-height: 30px;
  background-color: #FFB800;
  font-weight: bolder;
  padding: 5px;
  box-shadow: 1px 1px 5px grey;
}

`, "",{"version":3,"sources":["webpack://./src/pages/ch3/optimizer.css"],"names":[],"mappings":"AAAA;EACE,2BAAsB;EAAtB,sBAAsB;EACtB,sCAAsC;EACtC,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,mDAAmD;EACnD,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;;AAEpB;;;AAGA;;EAEE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;;AAGA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;AAC9B;;;;AAIA,aAAa;;AAEb;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;;EAEjB,mBAAmB;EACnB,YAAY;;AAEd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;AAC9B","sourcesContent":[".main-vis-container{\n  min-width: fit-content;\n  background-color: rgba(0, 0, 0, 0.062);\n  margin: 10px 2rem;\n  padding: 1.2rem;\n}\n.practice-bullet-point{\n  min-width: calc(100% - 4rem);\n  min-height: 40px;\n  margin: 10px 2rem;\n  font-size: 1.2rem;\n  font-weight: bolder;\n  line-height: 40px;\n  text-shadow: 3px 3px 3px rgba(226, 223, 223, 0.747);\n  list-style-type: circle;\n  background-color: #ffb70031;\n  box-shadow: 4px 4px 10px #00000042;\n}\n\n.apply-button{\n  width: 150px;\n  height:30px;\n  font-size: 12px;\n  text-align: center;\n  \n}\n\n\n.progress-label,\n.epoch-count{\n  width: 120px;\n  height: 30px;\n  font-size: 1.2rem;\n  font-weight: bolder;\n  line-height: 30px;\n}\n\n\n.optimizer-info-table tr td{\n  padding: 5px;\n  border: 1px solid black;\n  width: 200px;\n  font-size: 1.2rem;\n  font-weight: bolder;\n  text-align: center;\n  background-color: white;\n  box-shadow: 1px 1px 5px grey;\n}\n\n\n\n/* Practice */\n\n.data-description{\n  width: 100%;\n  height: 80px;\n  line-height: 35px;\n\n  font-weight: bolder;\n  padding: 5px;\n\n}\n\n.data-loss-description{\n  width: 100%;\n  height: 40px;\n  line-height: 30px;\n  background-color: #FFB800;\n  font-weight: bolder;\n  padding: 5px;\n  box-shadow: 1px 1px 5px grey;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
